export default __webpack_public_path__ + "static/media/achievement-3.7f04b385.jpg";